import { Backdrop } from "@mui/material";
import { FC } from "react";
import { Loader as Pulse } from "./Loader";

const Loader: FC = () => (
  <Backdrop
    open
    sx={{
      top: "0",
      left: "0",
      position: "absolute",
      bgcolor: `rgba(255,255,255,0.4)`,
      zIndex: "100",
      backdropFilter: "blur(2px)",
    }}
  >
    <Pulse />
  </Backdrop>
);

export default Loader;
